var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 32,
    viewBox: "0 0 92 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_839_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 9,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.823201 12.4683C0.307138 12.8368 0 13.4428 0 14.0894V25H6.45525C7.51059 25 8.36594 24.1176 8.36594 23.029V7.08765L0.824987 12.4665L0.823201 12.4683Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_839_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.56628 29.2053L36.0312 29.2053V2.88207L-6.56628 2.88207V29.2053Z",
    fill: "url(#paint0_linear_839_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_839_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 7,
    width: 9,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.917 12.4683C21.4009 12.8368 21.0938 13.4428 21.0938 14.0894V25H27.549C28.6043 25 29.4597 24.1176 29.4597 23.029V7.08765L21.9187 12.4665L21.917 12.4683Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_839_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0336 2.88208H16.1875V29.2053H36.0336V2.88208Z",
    fill: "url(#paint1_linear_839_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_839_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9463 7.08765H8.375L16.6624 23.8211C17.0213 24.545 17.7409 25 18.5284 25H25.864L17.8231 8.29052C17.4695 7.55553 16.7409 7.08949 15.9445 7.08949L15.9463 7.08765Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_839_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.55847 29.2053L36.0391 29.2053V2.88207L-6.55847 2.88207V29.2053Z",
    fill: "#EC2D63"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9713 14.5338C45.773 13.9702 45.4838 13.4433 45.107 12.9662C44.7284 12.4836 44.2284 12.0894 43.6231 11.7947C43.0177 11.4999 42.2642 11.3489 41.382 11.3489C40.2338 11.3489 39.2374 11.6105 38.4214 12.1244C38.2839 12.211 38.1517 12.3031 38.025 12.4025C37.9125 12.4891 37.7714 12.502 37.6428 12.4357C37.5107 12.3675 37.4303 12.2368 37.4303 12.0839C37.4303 11.6786 37.1107 11.3489 36.7178 11.3489H35.65C35.2571 11.3489 34.9375 11.6786 34.9375 12.0839V24.155C34.9375 24.5602 35.2571 24.89 35.65 24.89H37.0053C37.3982 24.89 37.7178 24.5602 37.7178 24.155V18.0301C37.7178 17.2896 37.7982 16.6541 37.9571 16.1438C38.1142 15.6391 38.3303 15.2283 38.6017 14.9225C38.8696 14.6204 39.1874 14.3975 39.5446 14.2594C39.9089 14.1212 40.2999 14.0494 40.7088 14.0494C41.3338 14.0494 41.8445 14.1801 42.2249 14.438C42.6106 14.6978 42.9124 15.0441 43.1249 15.4678C43.3427 15.9006 43.4927 16.3777 43.5695 16.8843C43.6481 17.4001 43.6891 17.9103 43.6891 18.3985V24.155C43.6891 24.5602 44.0088 24.89 44.4016 24.89H45.757C46.1498 24.89 46.4695 24.5602 46.4695 24.155V17.5769C46.4695 17.1735 46.4337 16.7019 46.3641 16.1733C46.2945 15.6409 46.1587 15.0883 45.9641 14.532L45.9713 14.5338Z",
    fill: "#160F3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3186 12.2647C57.4275 11.6587 56.3347 11.3511 55.0722 11.3511C53.8097 11.3511 52.7901 11.6366 51.8776 12.1966C50.9634 12.7584 50.2419 13.5652 49.733 14.5931C49.2259 15.6155 48.9688 16.8386 48.9688 18.2257C48.9688 19.5373 49.2295 20.707 49.7455 21.7054C50.2634 22.7056 50.9973 23.4959 51.9294 24.054C52.8598 24.6103 53.9544 24.894 55.1829 24.894C56.4115 24.894 57.49 24.5753 58.4704 23.9472C59.265 23.4369 59.9061 22.748 60.3757 21.8988C60.4811 21.7072 60.4971 21.4788 60.4186 21.2706C60.34 21.0625 60.1757 20.9041 59.9686 20.8359L58.7025 20.4215C58.39 20.3201 58.0543 20.4436 57.8883 20.7254C57.6258 21.1638 57.29 21.5175 56.8865 21.7772C56.3811 22.1014 55.7722 22.2654 55.074 22.2654C54.0026 22.2654 53.208 21.9172 52.6473 21.2007C52.2883 20.7438 52.0401 20.1488 51.9116 19.4341C51.8919 19.3217 51.9205 19.2075 51.9919 19.1191C52.0651 19.0288 52.1705 18.9773 52.283 18.9773H60.1614C60.5471 18.9773 60.8686 18.6549 60.8757 18.257C60.8971 16.9731 60.715 15.8292 60.3311 14.8602C59.89 13.7439 59.2132 12.8708 58.3204 12.2629L58.3186 12.2647ZM57.9365 16.5973C57.8633 16.6894 57.7561 16.7428 57.64 16.7428H52.3794C52.2598 16.7428 52.1491 16.6857 52.0776 16.5881C52.008 16.4923 51.9848 16.3744 52.0151 16.2602C52.1562 15.7297 52.3687 15.2784 52.6473 14.9173C53.2026 14.2008 54.049 13.836 55.1633 13.836C56.1793 13.836 56.9133 14.1547 57.4025 14.8105C57.6793 15.1807 57.8847 15.6744 58.0097 16.2805C58.0329 16.391 58.0061 16.5052 57.9365 16.5955V16.5973Z",
    fill: "#160F3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9427 18.2788C69.8427 18.1406 69.8427 17.9546 69.9427 17.8164L73.7391 12.5223C73.8998 12.2975 73.9248 12.0028 73.8016 11.7541C73.6801 11.5055 73.4355 11.3489 73.1641 11.3489H71.5873C71.3587 11.3489 71.1409 11.4631 71.007 11.6565L68.4606 15.3222C68.3892 15.4254 68.2784 15.4843 68.1552 15.4843C68.0338 15.4843 67.9213 15.4254 67.8499 15.3241L65.2713 11.6547C65.1374 11.4649 64.9214 11.3507 64.6946 11.3507H63.116C62.8446 11.3507 62.6017 11.5055 62.4785 11.756C62.3571 12.0047 62.3803 12.2994 62.5428 12.5241L66.3392 17.8182C66.4374 17.9564 66.4374 18.1425 66.3392 18.2806L62.4375 23.7221C62.2768 23.9468 62.2518 24.2416 62.3732 24.4902C62.4946 24.7389 62.7392 24.8955 63.0107 24.8955H64.5999C64.8285 24.8955 65.0446 24.7813 65.1785 24.5916L67.8534 20.7766C67.9249 20.6735 68.0392 20.6145 68.1588 20.6164C68.282 20.6164 68.3927 20.6753 68.4642 20.7785L71.1177 24.5897C71.2516 24.7813 71.4677 24.8955 71.6962 24.8955H73.2837C73.5551 24.8955 73.798 24.7408 73.9212 24.4902C74.0426 24.2397 74.0176 23.945 73.8569 23.7221L69.9445 18.2824L69.9427 18.2788Z",
    fill: "#160F3E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8088 13.832C85.4195 12.9717 84.7963 12.3362 83.9606 11.9383C83.1374 11.5478 82.1606 11.3489 81.0571 11.3489C79.6285 11.3489 78.4642 11.6786 77.5982 12.3307C76.8928 12.8612 76.3643 13.552 76.0268 14.3828C75.95 14.5725 75.9553 14.788 76.0393 14.9741C76.125 15.162 76.2839 15.3057 76.4768 15.3664L77.641 15.7367C77.9803 15.8454 78.341 15.6796 78.4964 15.3425C78.6982 14.9096 78.991 14.5799 79.366 14.3644C79.8696 14.0751 80.4303 13.9296 81.0338 13.9296C81.9892 13.9296 82.666 14.1507 83.0463 14.5836C83.2909 14.8636 83.457 15.2486 83.5392 15.7275C83.5588 15.8362 83.5338 15.9467 83.4713 16.0351C83.4106 16.1199 83.3231 16.1751 83.2213 16.1899L82.3606 16.3151C81.6088 16.4238 80.8838 16.5398 80.2053 16.6633C79.5214 16.7867 78.8999 16.9322 78.3535 17.098C77.7178 17.3117 77.1714 17.5954 76.7321 17.9417C76.2857 18.2935 75.9446 18.7245 75.7161 19.2274C75.4893 19.7266 75.375 20.3124 75.375 20.9682C75.375 21.6737 75.5393 22.3313 75.8625 22.9226C76.1875 23.5158 76.6714 23.9984 77.3018 24.3558C77.9303 24.7113 78.716 24.8918 79.6374 24.8918C80.791 24.8918 81.782 24.6487 82.5785 24.1679C82.7999 24.0352 83.0142 23.8787 83.2142 23.7074C83.332 23.606 83.4838 23.5858 83.6195 23.6521C83.7534 23.7166 83.8338 23.8474 83.8338 24.0021V24.1642C83.8338 24.5639 84.1499 24.8955 84.5374 24.8992L85.5016 24.9121H85.5106C85.6981 24.9121 85.8766 24.8366 86.0105 24.7002C86.148 24.5621 86.223 24.376 86.223 24.1789L86.2445 16.6743C86.2445 16.1475 86.2213 15.6464 86.1766 15.1859C86.1302 14.7125 86.0034 14.2575 85.8016 13.832H85.8088ZM80.0588 22.5653C79.5856 22.5653 79.1946 22.4897 78.8982 22.3405C78.6089 22.195 78.391 21.9979 78.2517 21.7548C78.1107 21.5098 78.0392 21.2371 78.0392 20.9461C78.0392 20.655 78.1035 20.3972 78.2303 20.1964C78.3625 19.9864 78.5446 19.8058 78.7732 19.6585C79.0124 19.5037 79.2892 19.3693 79.5928 19.2606C79.966 19.139 80.3981 19.034 80.8785 18.9474C81.3678 18.859 81.9195 18.7669 82.5177 18.6767L83.1231 18.5845C83.1409 18.5809 83.1606 18.5809 83.1784 18.5809C83.2713 18.5809 83.3606 18.6159 83.4302 18.6803C83.5142 18.7577 83.5588 18.8682 83.5534 18.9843V19.0082C83.5338 19.4466 83.4659 19.8445 83.3481 20.1945C83.3427 20.2093 83.3392 20.2258 83.3356 20.2406C83.2517 20.6164 83.0695 20.9866 82.7981 21.3385C82.5231 21.694 82.1535 21.9924 81.6999 22.2226C81.2463 22.4529 80.6946 22.569 80.0571 22.569L80.0588 22.5653Z",
    fill: "#160F3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2526 7H89.9312C89.5377 7 89.2188 7.32907 89.2188 7.73499V9.02813C89.2188 9.43405 89.5377 9.76311 89.9312 9.76311H91.2526C91.6461 9.76311 91.9651 9.43405 91.9651 9.02813V7.73499C91.9651 7.32907 91.6461 7 91.2526 7Z",
    fill: "#160F3E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2875 11.3489H89.9C89.5065 11.3489 89.1875 11.6779 89.1875 12.0839V24.1568C89.1875 24.5627 89.5065 24.8918 89.9 24.8918H91.2875C91.681 24.8918 92 24.5627 92 24.1568V12.0839C92 11.6779 91.681 11.3489 91.2875 11.3489Z",
    fill: "#160F3E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_839_2",
    x1: 3.88355,
    y1: 35.4279,
    x2: 26.609,
    y2: -2.73034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#21103F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3E1444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#6E1B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#AF2458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EC2D63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_839_2",
    x1: 34.1158,
    y1: 1.73999,
    x2: 17.3471,
    y2: 29.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#160F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#21103F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3E1444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6E1B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AF2458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EC2D63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.74a994a1a5bed1b42d3f367b701f9839.svg";
export { ForwardRef as ReactComponent };